import { useCallback } from "react";

import { GaEvent } from "./static";
import useGAEvents from "./useGAEvents";

export interface UseGAProps {
  triggerGAEvent: (id: GaEvent | string, data?: any) => void;
}

const useGA = (): UseGAProps => {
  const { eventFactory, getVehicleParams } = useGAEvents();

  const triggerGAEvent = useCallback(
    (event: string, extraParams?: any) => {
      switch (event) {
        case GaEvent.ACCORDION_CLICK:
          eventFactory?.[GaEvent.ACCORDION_CLICK]?.(extraParams);
          break;

        case GaEvent.ADJUST_LEASE_OPTION:
          eventFactory?.[GaEvent.ADJUST_LEASE_OPTION]?.(extraParams);
          break;

        case GaEvent.BUTTON_CLICKS:
          eventFactory?.[GaEvent.BUTTON_CLICKS]?.(extraParams);
          break;

        case GaEvent.BOOK_TEST_DRIVE:
          eventFactory?.[GaEvent.BOOK_TEST_DRIVE]?.(extraParams);
          break;

        case GaEvent.CLICK_TO_CALL:
          eventFactory?.[GaEvent.CLICK_TO_CALL]?.(extraParams);
          break;

        case GaEvent.CONFIGURATOR_INTERACT_3D: {
          eventFactory?.[GaEvent.CONFIGURATOR_INTERACT_3D]?.(extraParams);
          break;
        }

        case GaEvent.CONFIGURATOR_SELECT_ACCESSORY: {
          eventFactory?.[GaEvent.CONFIGURATOR_SELECT_TAB]?.(extraParams);
          break;
        }

        case GaEvent.CONFIGURATOR_SELECT_GRADE:
          eventFactory?.[GaEvent.CONFIGURATOR_SELECT_GRADE]?.(extraParams);
          break;

        case GaEvent.CONFIGURATOR_SELECT_COLOUR_TRIM: {
          eventFactory?.[GaEvent.CONFIGURATOR_SELECT_COLOUR_TRIM]?.(extraParams);
          break;
        }

        case GaEvent.CONFIGURATOR_SELECT_TAB:
          eventFactory?.[GaEvent.CONFIGURATOR_SELECT_TAB]?.(extraParams);
          break;

        case GaEvent.COPY_VEHICLE_CONFIGURATION_LINK:
          eventFactory?.[GaEvent.COPY_VEHICLE_CONFIGURATION_LINK]?.();
          break;

        case GaEvent.DEALER_NEXT_STEPS:
          eventFactory?.[GaEvent.DEALER_NEXT_STEPS]?.(extraParams);
          break;

        case GaEvent.DOWNLOAD_BROCHURE_PDF:
          eventFactory?.[GaEvent.DOWNLOAD_BROCHURE_PDF]?.();
          break;

        case GaEvent.DOWNLOAD_FULL_SPEC_SHEET:
          eventFactory?.[GaEvent.DOWNLOAD_FULL_SPEC_SHEET]?.(extraParams);
          break;

        case GaEvent.EMAIL_DEALER:
          eventFactory?.[GaEvent.EMAIL_DEALER]?.(extraParams);
          break;

        case GaEvent.ERROR_MESSAGE:
          eventFactory?.[GaEvent.ERROR_MESSAGE]?.(extraParams);
          break;

        case GaEvent.LAUNCH_AR:
          eventFactory?.[GaEvent.LAUNCH_AR]?.();
          break;

        case GaEvent.LAUNCH_AR_AVAILABILITY:
          eventFactory?.[GaEvent.LAUNCH_AR_AVAILABILITY]?.(extraParams);
          break;

        case GaEvent.PAGE_VIEW:
          eventFactory?.[GaEvent.PAGE_VIEW]?.(extraParams);
          break;

        case GaEvent.SAVE_VEHICLE_CONFIGURATION:
          eventFactory?.[GaEvent.SAVE_VEHICLE_CONFIGURATION]?.(extraParams);
          break;

        case GaEvent.SPEC_COMPARE_GRADES: {
          const { vehicleModel } = getVehicleParams?.() ?? {};
          eventFactory?.[GaEvent.SPEC_COMPARE_GRADES]?.({
            vehicleModel,
            ...extraParams,
          });
          break;
        }

        case GaEvent.SPEC_SELECT_GRADE: {
          const { vehicleModel } = getVehicleParams?.() ?? {};
          eventFactory?.[GaEvent.SPEC_SELECT_GRADE]?.({
            vehicleModel,
            ...extraParams,
          });
          break;
        }

        case GaEvent.SUBMIT_SAVE_VEHICLE_FORM:
          eventFactory?.[GaEvent.SUBMIT_SAVE_VEHICLE_FORM]?.();
          break;

        case GaEvent.TOYOTA_FOR_YOU_CORE_PAGE:
          eventFactory?.[GaEvent.TOYOTA_FOR_YOU_CORE_PAGE]?.(extraParams);
          break;

        case GaEvent.VIEW_FEATURES:
          eventFactory?.[GaEvent.VIEW_FEATURES]?.(extraParams);
          break;

        case GaEvent.VIEW_FINANCE_OPTIONS:
          eventFactory?.[GaEvent.VIEW_FINANCE_OPTIONS]?.(extraParams);
          break;

        case GaEvent.VIEW_IN_AR:
          eventFactory?.[GaEvent.VIEW_IN_AR]?.(extraParams);
          break;

        case GaEvent.VIEW_SCREEN: {
          eventFactory?.[GaEvent.VIEW_SCREEN]?.(extraParams);
          break;
        }
        case GaEvent.VIEW_SPECS_AND_GRADES:
          eventFactory?.[GaEvent.VIEW_SPECS_AND_GRADES]?.(extraParams);
          break;

        default:
        // do nothing
      }
    },
    [eventFactory, getVehicleParams],
  );

  return { triggerGAEvent };
};

export default useGA;
